// extracted by mini-css-extract-plugin
module.exports = {"item":"List_item_3fwFN","image":"List_image_3cFsm"};